<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.goodsreceipt') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.vendor')"
              :subtitle="$t('series.gr')+' ' + nextGrCode"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.storecompanyperson') }}</label>
                    <selectize
                      v-model="form.pickedVendorId"
                      :default="form.defaultVendorId"
                      :updateoption="form.updateOptionVendor"
                      :options="form.optionVendors"
                      :multiple="false"
                      :create="true"
                      :loading="form.loadingVendor"
                      :validation="form.trickValidationVendor"
                      :placeholder="$t('placeholder.selectorcreate')"
                      @add="onAddedVendor"/>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="form.pickedVendorId"
              class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <textarea
                      v-model="form.vendor.address"
                      class="form-control"
                      style="min-height: 107px;"/>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      v-model="form.vendor.tel"
                      type="text"
                      class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      v-model="form.vendor.email"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.date')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('apps.inventory.message.receiptdate') }}</label>
                    <BaseInputDatePicker
                      v-model="form.selectedDate"
                      mode="dateTime"
                      is24hr
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.inventory.message.shipto')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.store') }}</label>
                    <select
                      v-model="form.pickedWarehouseId"
                      class="form-control custom-select">
                      <option
                        v-for="(item, index) in warehouses"
                        v-if="item.is_deleted == false"
                        :key="index"
                        :value="item.warehouse_id">
                        {{ item.warehouse_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.orderlist')"/>
            <OrderGR
              v-if="isRenderOrders"
              :validation="form.trickValidation"
              :data="form.orders"
              :createAble="true"
              :showProductImage="true"
              :selectedWhId="form.pickedWarehouseId"
              :optionBinLocations="optionBinLocations"
              @submit="onSubmitOrder"
            />
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('placeholder.note') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.note"
                      class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-web"
              @click="form.trickValidation++;isCreateAnother = false">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-web"
              disabled><i class="fas fa-spinner spin"/></button>
          </div>
        </section>
      </template>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toISODateString } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'
import moment from 'moment'

export default {
  name: 'GoodsReceiptNew',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedWarehouseId: null,
        pickedVendorId: null,
        defaultVendorId: null,
        optionVendors: [],
        trickValidationVendor: 0,
        vendor: {
          address: null,
          email: null,
          tel: null,
        },
        updateOptionVendor: null,
        loadingVendor: false,
        note: '',
        selectedDate: moment().toDate(),
        trickValidation: 0,
        orders: [],
      },

      originalForm: null,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      isRenderOrders: true,
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      vendor: 'getVendor',
      vendors: 'getVendors',
      nextGrCode: 'getNextGrCode',
      getMainWarehouse: 'getMainWarehouse',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      getMainStock: 'getMainStock',
      getWarehouseInfo: 'getWarehouseInfo',
      dateformat: 'getDateFormat',
      getVendorById: 'getVendorById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
    }),
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    optionWarehouses () {
      const items = this.warehouses.map((item) => {
        return {
          text: item.warehouse_name,
          value: item.warehouse_id,
        }
      })
      return items
    },
    optionBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseId) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
  },
  watch: {
    ready: function (isReady) {
      if (isReady) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 3,
        submenuAtIdx: 1,
      })
    },
    async 'form.pickedWarehouseId' (after, before) {
      // get next grcode
      await this.$store.dispatch('getNextGrCode', {
        warehouse_id: this.form.pickedWarehouseId,
        short_name: this.getWarehouseInfo(this.form.pickedWarehouseId).short_name,
      })
      // loading finish
      this.showFinish(this.$Progress)

      this.isRenderOrders = false
      this.form.orders = []
      setTimeout(() => this.isRenderOrders = true, 10)
    },
    vendors: function (after, before) {
      this.form.optionVendors = []
      for (let i in after) {
        let vendor = after[i]
        this.form.optionVendors.push({
          text: vendor.vendor_name,
          value: vendor.vendor_id,
        })
      }
    },
    'form.pickedVendorId': {
      handler: function (after) {
        let vendor_id = after
        let vendorInfo = this.getVendorById(vendor_id)

        this.form.vendor.address = null
        this.form.vendor.email = null
        this.form.vendor.tel = null

        if (vendorInfo) {
          this.form.vendor.address = vendorInfo.address
          this.form.vendor.email = this.getPartnerContact(vendorInfo.contacts).email
          this.form.vendor.tel = this.getPartnerContact(vendorInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    // set date format
    this.formats.input = [this.dateformat + ' HH:mm:ss']
    this.formats.dayPopover = this.dateformat + ' HH:mm:ss'
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
    // get vendors
    await this.$store.dispatch('getVendors')
    // set default
    this.setData()
    // ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 3,
      submenuAtIdx: 1,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearVendor', 'clearVendors', 'clearProducts'])
  },
  methods: {
    async onAddedVendor (value) {
      // show loading selectize
      this.form.loadingVendor = true

      // insert new vendor
      let res = await this.$store.dispatch('insertVendor', { name: value })

      if (res.success) {
        let vendor = res.data
        // update option value
        this.form.updateOptionVendor = {
          text: value,
          value: vendor.vendor_id,
          picked: true,
        }
        this.form.optionVendors.push({
          text: value,
          value: vendor.vendor_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingVendor = false
      }
    },
    async clearForm () {
      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      // get next grcode
      await this.$store.dispatch('getNextGrCode', {
        warehouse_id: this.getMainWarehouse.warehouse_id,
        short_name: this.getMainWarehouse.short_name,
      })

      this.ready = true

      // scroll to top
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    },
    onSubmitOrder (isValid, data) {
      this.form.trickValidationVendor++

      let isInValid = !isValid || (this.form.pickedVendorId == null || this.form.pickedVendorId == '')

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.save(data)
    },
    async save (data) {
      var orders = []

      for (let i in data) {
        let order = data[i]
        var getSku = this.getSkuInfoBySkuId(order.sku_id)
        var stocks

        if (!getSku) {
          let resGetProduct = await this.$store.dispatch('getProduct', {
            sku_id: order.sku_id,
          })
          let product = resGetProduct.data[0]
          let sku = product.prices.find(sku => sku.sku_id == order.sku_id)
          stocks = sku.stocks
        } else {
          stocks = getSku.stocks
        }

        let stock = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseId)

        const newOrder = {
          'sku_id': order.sku_id,
          'item': order.item,
          'quantity': order.quantity,
          'stock_id': stock.stock_id,
          'warehouse_id': stock.warehouse_id,
          'bin_location_id': order.bin_location_id,
        }

        if (order.use_lot) {
          newOrder.lot_number = {
            'bin_location_id': order.lot.binId,
            'date_product': toISODateString(order.lot.dateProduct),
            'date_expire': toISODateString(order.lot.dateExpire),
            'cost': order.lot.cost,
          }
        }

        if (order.use_serial) {
          newOrder.serial_numbers = order.serials.map((ser) => {
            return {
              'bin_location_id': ser.binId,
              'serial_number': ser.serialNumber,
              'date_product': toISODateString(ser.dateProduct),
              'date_expire': toISODateString(ser.dateExpire),
              'cost': ser.cost,
            }
          })
        }

        orders.push(newOrder)
      }

      let dataSet = {
      	orders: orders,
      	stockin: {
      		warehouse_id: this.form.pickedWarehouseId,
      		short_name: this.getWarehouseInfo(this.form.pickedWarehouseId).short_name,
      	},
      	note: this.form.note.trim().length > 0 ? this.form.note.trim() : null,
      	po_id: null,
        vendor_id: this.form.pickedVendorId,
        scheduled_at: this.form.selectedDate ? this.form.selectedDate.toISOString() : this.moment().toISOString(),
      }

      // update vendor
      let dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', this.form.pickedVendorId, this.form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      // save data
      var res = await this.$store.dispatch('insertGoodsreceipt', dataSet)

      if (res.success) {
        let newGoodsReceipt = res.data.goodsreceipt

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newGoodsReceipt.gr_code }),
          color: 'success',
          icon: 'cloud',
        })

        if (!this.isCreateAnother) {
          // go to GoodsIssueAll page
          return this.$router.push({
            name: 'GoodsReceiptEdit',
            query: {
              gr_id: newGoodsReceipt._id,
              gr_code: newGoodsReceipt.gr_code,
              ignoreDiscardAlert: true,
            },
          })
        } else {
          this.clearForm()
        }
      }
    },
    async setData () {
      // set picked main warehouse id
      this.form.pickedWarehouseId = this.getMainWarehouse.warehouse_id
      // set originalForm
      this.originalForm = _.cloneDeep(this.form)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodsreceipt/New.vue